// import React from "react";

// const VisionMission = () => {
//   return (
//     <section className="space vision-mission-section">
//       <div className="container">

//         {/* Header */}
//         <div className="row justify-content-center text-center">
//           <div className="col-lg-8">
//             <div className="title-area">
//               <span className="sec-subtitle">Mumbai Airport Cab</span>
//               <h2 className="sec-title h1 text-white">
//                 Driven by Trust, Comfort & Timely Travel
//               </h2>
//               <p className="sec-text">
//                 We make airport transfers simple, safe, and stress-free with
//                 professional drivers and 24/7 reliable service across Mumbai.
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Cards */}
//         <div className="row mt-5">

//           {/* Vision */}
//           <div className="col-lg-6 mb-4">
//             <div className="vision-card">
//               <div className="icon-box">🌍</div>
//               <h3>Our Vision</h3>
//               <p className="text-white">
//                 To become Mumbai’s most trusted airport cab service, delivering
//                 world-class travel experiences with punctuality, safety, and
//                 customer-first comfort at every ride.
//               </p>
//             </div>
//           </div>

//           {/* Mission */}
//           <div className="col-lg-6 mb-4">
//             <div className="mission-card">
//               <div className="icon-box">🚖</div>
//               <h3>Our Mission</h3>
//               <p className="text-white">
//                 To provide affordable, on-time, and hassle-free airport transfers
//                 with professional drivers, clean vehicles, and 24/7 availability
//                 across Mumbai and nearby areas.
//               </p>
//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default VisionMission;



import React from "react";
import { FaEye, FaCarSide } from "react-icons/fa";

const VisionMission = () => {
  return (
    <section className="space vision-mission-section p-0 py-4">
      <div className="container">
        {/* Header */}
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <div className="title-area">
              <span className="sec-subtitle">Mumbai Airport Cab</span>
              <h2 className="sec-title h1 text-white">
                Driven by Trust, Comfort & Timely Travel
              </h2>
              <p className="sec-text">
                We make airport transfers simple, safe, and stress-free with
                professional drivers and 24/7 reliable service across Mumbai.
              </p>
            </div>
          </div>
        </div>

        {/* Cards */}
        <div className="row mt-5">
          {/* Vision */}
          <div className="col-lg-6 mb-4">
            <div className="vision-card text-center">
              <div className="icon-box">
                <FaEye />
              </div>

              <h3 className="text-white mt-3">Our Vision</h3>

              <p className="text-white">
                To become Mumbai’s most trusted airport cab service, delivering
                world-class travel experiences with punctuality, safety, and
                customer-first comfort at every ride.
              </p>
            </div>
          </div>

          {/* Mission */}
          <div className="col-lg-6 mb-4">
            <div className="mission-card text-center">
              <div className="icon-box">
                <FaCarSide />
              </div>

              <h3 className="text-white mt-3">Our Mission</h3>

              <p className="text-white">
                To provide affordable, on-time, and hassle-free airport
                transfers with professional drivers, clean vehicles, and 24/7
                availability across Mumbai and nearby areas.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Component CSS */}
      <style jsx>{`
        .vision-mission-section {
          background: #111827;
          padding: 80px 0;
        }

        .vision-card,
        .mission-card {
          background: rgba(255, 255, 255, 0.06);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 20px;
          padding: 40px 30px;
          transition: all 0.35s ease;
          backdrop-filter: blur(10px);
          height: 100%;
        }

        .vision-card:hover,
        .mission-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 15px 35px rgba(255, 180, 0, 0.25);
          border-color: #ffb400;
        }

        .icon-box {
          width: 85px;
          height: 85px;
          border-radius: 50%;
          background: linear-gradient(135deg, #ffb400, #ff7b00);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          color: #fff;
          font-size: 38px;
          box-shadow: 0 10px 30px rgba(255, 180, 0, 0.35);
          transition: all 0.35s ease;
        }

        .vision-card:hover .icon-box,
        .mission-card:hover .icon-box {
          transform: rotate(8deg) scale(1.08);
        }

        h3 {
          font-weight: 700;
          margin-bottom: 15px;
        }

        p {
          font-size: 16px;
          line-height: 1.8;
          color: rgba(255, 255, 255, 0.9);
        }
      `}</style>
    </section>
  );
};

export default VisionMission;